import React, { useState } from "react";
import Header from "../../components/Header";
import HomeTable from "../../components/HomeTable";
import TranslationUploadForm from "../../components/TranslationUploadForm";
import { Grid, Box, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const Translation = () => {
  const [openUploadForm, setOpenUploadForm] = useState(false);

  const handleOpenUploadForm = () => {
    setOpenUploadForm(true);
  };

  const handleCloseUploadForm = () => {
    setOpenUploadForm(false);
  };

  return (
    <Grid container spacing={4} height="100%">
      <Grid item sm={12} md={12}>
        <Box sx={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center"
        }}>
          <Header title="Translation" />
          <Button 
            variant="contained" 
            color="primary"
            startIcon={<CloudUploadIcon />}
            sx={{ height: "40px" }}
            onClick={handleOpenUploadForm}
          >
            Upload for Translation
          </Button>
        </Box>
      </Grid>
      <Grid item sm={12} md={12}>
        <HomeTable sortData="Translation"/>
      </Grid>

      {/* Translation Upload Form Dialog */}
      <TranslationUploadForm 
        open={openUploadForm} 
        onClose={handleCloseUploadForm} 
      />
    </Grid>
  );
};

export default Translation;